export default __webpack_public_path__ + "static/media/member.59225023.png";